export enum SystemAlertSnackBarMessage {
  BUTTON_LABEL_ACKNOWLEDGE = 'Okay',
}
